import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DashboardDataQueryVariables = Types.Exact<{
  organisation_id: Types.Scalars["Int"];
  currency_book_id?: Types.Maybe<Types.Scalars["Int"]>;
  business_unit_id?: Types.Maybe<Types.Scalars["Int"]>;
}>;

export type DashboardDataQuery = { __typename?: "query_root" } & {
  currency_books: Array<
    { __typename?: "currency_books" } & Pick<Types.Currency_Books, "id"> & {
        currency: { __typename?: "currencies" } & Pick<
          Types.Currencies,
          "prefix"
        >;
        currency_book_liquidity_limits: Array<
          { __typename?: "currency_book_liquidity_limits" } & Pick<
            Types.Currency_Book_Liquidity_Limits,
            | "upper_limit_pct"
            | "lower_limit_pct"
            | "notice_days_lt"
            | "notice_days_gte"
          >
        >;
        currency_book_bank_exposure_limits: Array<
          { __typename?: "currency_book_bank_exposure_limits" } & Pick<
            Types.Currency_Book_Bank_Exposure_Limits,
            "currency_book_id" | "bank_id" | "exposure_limit"
          >
        >;
      }
  >;
  business_units: Array<
    { __typename?: "business_units" } & {
      business_unit_liquidity_limits: Array<
        { __typename?: "business_unit_liquidity_limits" } & Pick<
          Types.Business_Unit_Liquidity_Limits,
          | "upper_limit_pct"
          | "lower_limit_pct"
          | "notice_days_lt"
          | "notice_days_gte"
        >
      >;
      business_unit_bank_exposure_limits: Array<
        { __typename?: "business_unit_bank_exposure_limits" } & Pick<
          Types.Business_Unit_Bank_Exposure_Limits,
          "business_unit_id" | "bank_id" | "exposure_limit"
        >
      >;
    }
  >;
  organisations_by_pk?: Types.Maybe<
    { __typename?: "organisations" } & {
      bank_accounts: Array<
        { __typename?: "bank_accounts" } & Pick<
          Types.Bank_Accounts,
          | "account_id"
          | "bank_id"
          | "product_type"
          | "notice_days"
          | "fixed_maturity_date"
          | "opening_interest_rate"
          | "currency_id"
          | "currency_book_id"
        > & {
            bank?: Types.Maybe<
              { __typename?: "banks" } & Pick<Types.Banks, "name"> & {
                  image?: Types.Maybe<
                    { __typename?: "uploads" } & Pick<
                      Types.Uploads,
                      "public_url"
                    >
                  >;
                }
            >;
            currency: { __typename?: "currencies" } & Pick<
              Types.Currencies,
              "name" | "prefix"
            >;
            currency_book: { __typename?: "currency_books" } & Pick<
              Types.Currency_Books,
              "name"
            > & {
                business_unit: { __typename?: "business_units" } & Pick<
                  Types.Business_Units,
                  "name"
                >;
              };
            actual_balances: Array<
              { __typename?: "actual_balances" } & Pick<
                Types.Actual_Balances,
                | "date"
                | "created_at"
                | "balance"
                | "balance_gbp"
                | "balance_eur"
                | "balance_usd"
                | "interest_rate"
                | "maturity_date"
              >
            >;
            model_balances: Array<
              { __typename?: "model_balances" } & Pick<
                Types.Model_Balances,
                "balance" | "balance_gbp"
              >
            >;
          }
      >;
      organisation_bank_exposure_limits: Array<
        { __typename?: "organisation_bank_exposure_limits" } & Pick<
          Types.Organisation_Bank_Exposure_Limits,
          "bank_id" | "exposure_limit"
        >
      >;
      organisation_liquidity_limits: Array<
        { __typename?: "organisation_liquidity_limits" } & Pick<
          Types.Organisation_Liquidity_Limits,
          | "upper_limit_pct"
          | "lower_limit_pct"
          | "notice_days_lt"
          | "notice_days_gte"
        >
      >;
    }
  >;
  actual_balances: Array<
    { __typename?: "actual_balances" } & Pick<
      Types.Actual_Balances,
      | "date"
      | "created_at"
      | "balance_gbp"
      | "balance_eur"
      | "balance_usd"
      | "interest_rate"
      | "bank_account_id"
    > & {
        bank_account: { __typename?: "bank_accounts" } & Pick<
          Types.Bank_Accounts,
          "organisation_id"
        > & {
            currency: { __typename?: "currencies" } & Pick<
              Types.Currencies,
              "prefix"
            >;
            currency_book: { __typename?: "currency_books" } & Pick<
              Types.Currency_Books,
              "id"
            >;
          };
      }
  >;
};

export const DashboardDataDocument = gql`
  query DashboardData(
    $organisation_id: Int!
    $currency_book_id: Int
    $business_unit_id: Int
  ) {
    currency_books(where: { id: { _eq: $currency_book_id } }, limit: 1) {
      id
      currency {
        prefix
      }
      currency_book_liquidity_limits {
        upper_limit_pct
        lower_limit_pct
        notice_days_lt
        notice_days_gte
      }
      currency_book_bank_exposure_limits {
        currency_book_id
        bank_id
        exposure_limit
      }
    }
    business_units(where: { id: { _eq: $business_unit_id } }, limit: 1) {
      business_unit_liquidity_limits {
        upper_limit_pct
        lower_limit_pct
        notice_days_lt
        notice_days_gte
      }
      business_unit_bank_exposure_limits {
        business_unit_id
        bank_id
        exposure_limit
      }
    }
    organisations_by_pk(id: $organisation_id) {
      bank_accounts(
        where: {
          _and: [
            { currency_book_id: { _eq: $currency_book_id } }
            { currency_book: { business_unit_id: { _eq: $business_unit_id } } }
          ]
        }
        order_by: { account_id: asc }
      ) {
        account_id
        bank_id
        product_type
        notice_days
        fixed_maturity_date
        opening_interest_rate
        bank {
          name
          image {
            public_url
          }
        }
        currency_id
        currency {
          name
          prefix
        }
        currency_book_id
        currency_book {
          name
          business_unit {
            name
          }
        }
        actual_balances(limit: 2, order_by: [{ date: desc }]) {
          date
          created_at
          balance
          balance_gbp
          balance_eur
          balance_usd
          interest_rate
          maturity_date
        }
        model_balances(limit: 1) {
          balance
          balance_gbp
        }
      }
      organisation_bank_exposure_limits {
        bank_id
        exposure_limit
      }
      organisation_liquidity_limits {
        upper_limit_pct
        lower_limit_pct
        notice_days_lt
        notice_days_gte
      }
    }
    actual_balances(
      order_by: [{ date: desc }, { created_at: desc }]
      where: {
        _and: {
          balance_gbp: { _is_null: false }
          bank_account: {
            organisation_id: { _eq: $organisation_id }
            currency_book: {
              id: { _eq: $currency_book_id }
              business_unit_id: { _eq: $business_unit_id }
            }
          }
        }
      }
    ) {
      date
      created_at
      balance_gbp
      balance_eur
      balance_usd
      interest_rate
      bank_account_id
      bank_account {
        organisation_id
        currency {
          prefix
        }
        currency_book {
          id
        }
      }
    }
  }
`;

export function useDashboardDataQuery(
  options: Omit<Urql.UseQueryArgs<DashboardDataQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<DashboardDataQuery>({
    query: DashboardDataDocument,
    ...options,
  });
}
